import SecurityFraudComponent from './SecurityAndfraudAlertsComponent';

export default SecurityFraudComponent;